import React from "react";
import "../Careers/InternshipIndia.css";
import InquiryForm from "./InquiryForm"; // adjust path to your InquiryForm

const features = [
  { icon: "🏢", title: "Practical Work Experience", desc: "Hands-on experience in renowned Indian corporate companies across multiple industries." },
  { icon: "👨‍💼", title: "Senior Guidance", desc: "Real work experience under the direct guidance and mentorship of seasoned professionals." },
  { icon: "📈", title: "Skills & Knowledge", desc: "Develop professional skills and industry knowledge through live projects and assignments." },
  { icon: "🏭", title: "Industry Visits", desc: "Visits to industries and facilities tailored to your specific work requirements and field." },
  { icon: "🏗️", title: "Multi-Department Exposure", desc: "Work experience across various departments of the company for a holistic understanding." },
  { icon: "🎤", title: "Personality Development", desc: "Classes covering Time Management, Stress & Anger Management, Interview Skills, and Communication." },
  { icon: "📜", title: "Experience Certificate", desc: "Internationally recognized experience certificate awarded upon successful completion." },
  { icon: "🏠", title: "Stay / Hostel Facility", desc: "Comfortable, safe, and fully managed hostel accommodation provided for all interns." },
  { icon: "🍽️", title: "Daily Meals Included", desc: "Daily Breakfast, Lunch & Dinner included — no extra costs for food during your stay." },
  { icon: "🚐", title: "Pick-up & Drop", desc: "Daily office-to-home pick-up and drop facility for groups of 5 or more students." },
  { icon: "🌐", title: "Free Language Classes", desc: "Free A1, A2 Level Foreign Language classes — choose from French, English, German, Hindi, or Spanish." },
  { icon: "🗺️", title: "Golden Triangle Tour", desc: "5 Night 6 Days tour to India's iconic Golden Triangle — Delhi, Agra & Jaipur included." },
  { icon: "✈️", title: "Airport Transfer", desc: "Hassle-free airport pick-up and drop service arranged for all international interns." },
  { icon: "🛟", title: "24/7 Support", desc: "Round-the-clock support team available to assist you throughout your internship journey." },
];

const careerFields = [
  "Hotel, Hospitality & Travel Management",
  "Import and Export Business",
  "Architecture & Interior Design Engineering",
  "Agricultural and Horticultural",
  "Information Technology & Software Engineering",
  "Education",
  "Mechanical & Industrial Engineers",
  "Finance",
  "Automobile Engineers",
  "Pharmaceuticals & Biotechnology",
  "Sales and Marketing",
  "Psychology",
  "Business Development",
  "Veterinary Science",
  "Human Resources (H.R.)",
  "Social Work",
  "Events Management",
  "Film and Television",
  "Medical & Paramedical Fields",
];

const stats = [
  { num: "1.4B+", label: "Population — World's Largest Democracy" },
  { num: "#5", label: "World's Largest Economy by GDP" },
  { num: "28+", label: "States with Diverse Cultures" },
  { num: "22+", label: "Official Languages Spoken" },
];

const InternshipIndia = () => {
  return (
    <div className="ind-page">

      {/* ── HERO ── */}
      <section className="ind-hero">
        <div className="ind-container">
          <div className="ind-hero-inner">

            {/* Left text */}
            <div>
              <span className="ind-hero-flag">🇮🇳</span>
              <div className="ind-hero-tag">✦ Internship Program</div>
              <h1>
                Work & Grow in<br />
                <span>Incredible India</span>
              </h1>
              <p className="ind-hero-desc">
                India is the fastest growing major economy in the world — a land of diverse
                cultures, brilliant youth, and boundless opportunity. Gain real-world experience
                in one of Asia's most dynamic professional environments.
              </p>
              <div className="ind-hero-badges">
                <span className="ind-hero-badge">🏆 Top Corporate Placements</span>
                <span className="ind-hero-badge">🌏 14+ Career Fields</span>
                <span className="ind-hero-badge">🎓 Certificate Awarded</span>
                <span className="ind-hero-badge">🛫 Full Support Included</span>
              </div>
            </div>

            {/* Cost Card */}
            <div className="ind-cost-card">
              <h3>💼 Internship Investment</h3>

              <div className="ind-cost-item">
                <div className="ind-cost-duration">3 Months Internship</div>
                <div className="ind-cost-price">
                  US $3,200 <span style={{ fontSize: "1rem", opacity: .7 }}>/ €2,750</span>
                </div>
                <div className="ind-cost-note">Perfect for short-term exposure</div>
              </div>

              <div className="ind-cost-item">
                <div className="ind-cost-duration">6 Months Internship</div>
                <div className="ind-cost-price">
                  US $5,000 <span style={{ fontSize: "1rem", opacity: .7 }}>/ €4,300</span>
                </div>
                <div className="ind-cost-note">Deep immersive experience</div>
              </div>

              <div className="ind-cost-includes">
                ✅ Cost includes placement, stay &amp; food
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── ABOUT INDIA ── */}
      <section className="ind-about">
        <div className="ind-container">
          <div className="ind-about-inner">
            <div className="ind-about-text">
              <span className="ind-section-tag">About India</span>
              <h2 className="ind-section-title">Why Intern in India?</h2>
              <p>
                India, also known as the Republic of India, is a country in South Asia and the
                seventh largest country by area. With more than 1.4 billion people, it is the
                world's most populous democracy — and the fastest growing major economy on the planet.
              </p>
              <p>
                India is expected to become one of the top three economic powers in the world over
                the next 10–15 years, backed by its strong democratic institutions and global partnerships.
              </p>
              <p>
                You will experience incredible diversity — meeting people from different cultural
                backgrounds under one roof. India is a youth country: highly educated, talented, and
                driven young professionals who work with vision, ambition, and purpose.
              </p>
            </div>

            <div>
              <span className="ind-section-tag">Key Facts</span>
              <h2 className="ind-section-title" style={{ marginBottom: 24 }}>India at a Glance</h2>
              <div className="ind-stats-grid">
                {stats.map((s, i) => (
                  <div className="ind-stat-card" key={i}>
                    <div className="ind-stat-num">{s.num}</div>
                    <div className="ind-stat-label">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section className="ind-features">
        <div className="ind-container">
          <span className="ind-section-tag">What's Included</span>
          <h2 className="ind-section-title">Everything You Need to Succeed</h2>
          <p className="ind-section-sub">
            Our comprehensive internship package covers every aspect of your stay —
            from professional training to accommodation, meals, travel, and beyond.
          </p>
          <div className="ind-features-grid">
            {features.map((f, i) => (
              <div className="ind-feature-card" key={i}>
                <div className="ind-feature-icon">{f.icon}</div>
                <div>
                  <h4>{f.title}</h4>
                  <p>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CAREER FIELDS ── */}
      <section className="ind-careers">
        <div className="ind-container">
          <span className="ind-section-tag">Career Fields</span>
          <h2 className="ind-section-title">19 Fields to Choose From</h2>
          <p className="ind-section-sub">
            Whether you're in healthcare, technology, hospitality, or the arts —
            we have placements that match your passion and career goals.
          </p>
          <div className="ind-careers-grid">
            {careerFields.map((field, i) => (
              <div className="ind-career-pill" key={i}>
                <span className="ind-career-pill-dot" />
                {field}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── INQUIRY FORM ── */}
      <InquiryForm title="Apply for Internship in India" />

    </div>
  );
};

export default InternshipIndia;